export enum BookingStatus {
  ACCEPTED = "accepted",
  COMPLETED = "completed",
  CANCELED = "cancelled",
}
